export default "__VITE_ASSET__C$h0FpxX__"